<template>
    <el-drawer :title="`查看统计  (任务ID：${id})`" :visible.sync="drawerShow" :wrapperClosable="false" :destroy-on-close="true" size="auto"
        @close="close">
        <div class="drawer-content" v-loading="dataLoading">
            <el-table :data="tableData" size="mini" border show-summary>
                <el-table-column prop="name" label="支付渠道">
                </el-table-column>
                <el-table-column label="退款成功">
                    <el-table-column label="后付款">
                        <el-table-column prop="AfterSuccessNum" label="数量"></el-table-column>
                        <el-table-column prop="AfterSuccess" label="金额"></el-table-column>
                    </el-table-column>
                    <el-table-column label="预付款">
                        <el-table-column prop="BeforeSuccessNum" label="数量"></el-table-column>
                        <el-table-column prop="BeforeSuccess" label="金额"></el-table-column>
                    </el-table-column>
                    <el-table-column prop="successTotal" label="金额总计"></el-table-column>
                </el-table-column>
                <el-table-column label="退款失败">
                    <el-table-column label="后付款">
                        <el-table-column prop="AfterFailNum" label="数量"></el-table-column>
                        <el-table-column prop="AfterFail" label="金额"></el-table-column>
                    </el-table-column>
                    <el-table-column label="预付款">
                        <el-table-column prop="BeforeFailNum" label="数量"></el-table-column>
                        <el-table-column prop="BeforeFail" label="金额"></el-table-column>
                    </el-table-column>
                    <el-table-column prop="failTotal" label="金额总计"></el-table-column>
                </el-table-column>
            </el-table>
        </div>
        <div class="drawer-footer">
            <el-button @click="close">确 定</el-button>
        </div>
    </el-drawer>
</template>

<script>
export default {
    data() {
        return {
            drawerShow: false,
            dataLoading:false,
            id:'',
            data: null,
            tableData: []
        };
    },
    methods:{
        close(){
            this.data = null;
            this.tableData = [];
            this.drawerShow = false;
        },
        show(id){
            this.id = id || '';
            if(id){
                this.getData();
            }
            this.drawerShow = true;
        },
        //获取详情
        getData(){
            this.dataLoading = true;
            this.$request({
                url: '/batchRefund/summaryInformation',
                params: {taskId: this.id},
                method: "post",
            })
                .then((res) => {
                    const { state, msg, result } = res.data;
                    if (state == 1 && result) {
                        this.data = result;

                        let keys = Object.keys(this.data);

                        this.tableData = [
                            {
                                name: "支付宝",
                            },{
                                name: "微信",
                            },{
                                name: "财付通",
                            },{
                                name: "抖音",
                            },{
                                name: "云闪付",
                            }]

                        keys.map( v => {
                            this.data[v] = parseFloat(this.data[v]);
                            if( v.includes('aliPay') ){
                                this.tableData[0][v.replace('aliPay','')] = this.data[v];
                                this.tableData[0]["successTotal"] = this.data.aliPayAfterSuccess + this.data.aliPayBeforeSuccess;
                                this.tableData[0]["failTotal"] = this.data.aliPayAfterFail + this.data.aliPayBeforeFail;
                            }
                            if( v.includes('wxPay') ){
                                this.tableData[1][v.replace('wxPay','')] = this.data[v];
                                this.tableData[1]["successTotal"] = this.data.wxPayAfterSuccess + this.data.wxPayBeforeSuccess;
                                this.tableData[1]["failTotal"] = this.data.wxPayAfterFail + this.data.wxPayBeforeFail;
                            }
                            if( v.includes('tenPay') ){
                                this.tableData[2][v.replace('tenPay','')] = this.data[v];
                                this.tableData[2]["successTotal"] = this.data.tenPayAfterSuccess + this.data.tenPayBeforeSuccess;
                                this.tableData[2]["failTotal"] = this.data.tenPayAfterFail + this.data.tenPayBeforeFail;
                            }
                            if( v.includes('bytePay') ){
                                this.tableData[3][v.replace('bytePay','')] = this.data[v];
                                this.tableData[3]["successTotal"] = this.data.bytePayAfterSuccess + this.data.bytePayBeforeSuccess;
                                this.tableData[3]["failTotal"] = this.data.bytePayAfterFail + this.data.bytePayBeforeFail;
                            }
							if( v.includes('cloudFlashPay') ){
							    this.tableData[4][v.replace('cloudFlashPay','')] = this.data[v];
							    this.tableData[4]["successTotal"] = this.data.cloudFlashPayAfterSuccess + this.data.cloudFlashPayBeforeSuccess;
							    this.tableData[4]["failTotal"] = this.data.cloudFlashPayAfterFail + this.data.cloudFlashPayBeforeFail;
							}
                        })
                    } else {
                        this.$message.error(msg || "获取详情失败,请重试");
                    }
                })
                .catch(() => {
                    this.$message.error("获取详情失败,请重试");
                })
                .finally(() => {
                    this.dataLoading = false;
                });
        },
    }
};
</script>

<style lang="scss" scoped>
.info-table{
    td{
        border-right: 1px $--color-border-gary solid;
        &:last-child{
            border-right: 0;
        }
    }
}
</style>
